import CalibrationTable from "../components/calibrationTable/calibrationTable.js";

export default function Calibration() {
  return (
    <div>
      <CalibrationTable />
    </div>
  );
}
